module.exports = __webpack_public_path__ + "img/Schichtung.4d4fc485.svg";